module.exports = {
	"articleTitle1": "Best of Ann Arbor 2017: Full List ",
	"catImage": "orangestar.png",
	"totalCats": 1,
	"name": "The Barre Code",
	"articleLink2": "https://www.michigandaily.com/section/arts/new-restaurant-secondary",
	"articleSnippet1": "Apr 12, 2017 ... Best Place for a Workout: The Barre Code. Yoga Studio: Tiny Buddha Yoga. Bank\n/Credit Union: Chase Bank. Ann Arbor's Hidden Gem: The Arb ...",
	"articleSnippet2": "",
	"totalMisc": 0,
	"articleTitle2": "",
	"address": "500 E Washington St #1, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.280004,
		"lng": -83.742671
	},
	"tips": [],
	"articleLink1": "#",
	"categories": {
		"fitnesscenter": 1,
		"location": 1,
		"recarea": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/barrecode.json
// module id = 823
// module chunks = 0